export class GetUserAction {
  static readonly type = "[UserProfile] Get user";
}

export class GetUserFullAction {
  static readonly type = "[UserProfile] Get user full";
}

export class GetSitesAction {
  static readonly type = "[UserProfile] Get sites";
}
